var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelCorporateSuspendOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.286,
    cy: 25.523,
    r: 2.857,
    fill: "#F6F1EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.093,
    r: 2.857,
    fill: "#F6F1EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 6.691h7.761a3 3 0 0 1 3 3v11.987",
    stroke: "url(#py4lae8dka)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.526 2.307-3.667 3.637a1 1 0 0 0 0 1.42l3.916 3.885",
    stroke: "url(#hf7hye772b)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.393 25.317c0 2.02-1.653 3.668-3.704 3.668-2.052 0-3.705-1.648-3.705-3.668 0-2.02 1.653-3.669 3.704-3.669 2.052 0 3.705 1.649 3.705 3.669z",
    stroke: "url(#y298aivw7c)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.752 26.496H9.991a3 3 0 0 1-3-3V11.51",
    stroke: "url(#x0zp25umpd)",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.474 30.88 3.667-3.637a1 1 0 0 0 0-1.42l-3.916-3.885",
    stroke: "url(#zmramfxdre)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.607 7.87c0-2.02 1.653-3.667 3.705-3.667 2.051 0 3.704 1.648 3.704 3.668 0 2.02-1.653 3.668-3.704 3.668-2.052 0-3.705-1.648-3.705-3.668z",
    stroke: "url(#wv2vxurnff)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "py4lae8dka",
    x1: 22.026,
    y1: 12.197,
    x2: 16.086,
    y2: 12.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hf7hye772b",
    x1: 16.491,
    y1: 5.592,
    x2: 13.927,
    y2: 5.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y298aivw7c",
    x1: 26.673,
    y1: 24.145,
    x2: 21.782,
    y2: 24.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x0zp25umpd",
    x1: 9.974,
    y1: 20.991,
    x2: 15.914,
    y2: 20.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zmramfxdre",
    x1: 15.509,
    y1: 27.596,
    x2: 18.073,
    y2: 27.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wv2vxurnff",
    x1: 5.327,
    y1: 9.043,
    x2: 10.218,
    y2: 8.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelCorporateSuspendOrderIcon);
export default __webpack_public_path__ + "static/media/paltelCorporateSuspendOrderIcon.0fbf30b3a799d93f9fd13c028e463c01.svg";
export { ForwardRef as ReactComponent };